import { TenantSettings } from '../tenant-settings.types';

export const tbdsCommonTenantSettings: TenantSettings = {
  appName: 'The Big Data Showroom',
  companyDisplayName: 'TBDS Common',
  logoUrl: 'assets/tbds-common-logo.png',
  logoAlt: 'TBDS Common',
  primaryColor: '#1e88e5',
  primaryTextColor: '#ffffff',
  enableUserDataRequests: true,
};
